// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#GmapsLittlePc[data-v-792f0524]{width:100%;height:705px;border-radius:5px}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
